import { LayerTemplateModelDc } from "@evergis/api";
import { createMutation } from "@evergis/react-fetching";
import { api as evergisApi } from "../evergis/api";
import { promiseAllSettled } from "../utils/promiseAllSettled";

export const print = createMutation(
  (printTemplates: LayerTemplateModelDc[]) => async api => {
    const printPromises = printTemplates.map(template => api.print.print(template));
    const results = await promiseAllSettled(printPromises);

    return {
      data: results.map((image, i) => ({
        image,
        name: printTemplates[i].fileName,
        format: printTemplates[i].fileFormat,
      })),
    };
  },
  { injected: evergisApi },
);
